import { Component } from "../../helpers/compiler";

@Component({ className: 'js-intersect-item' })
export class IntersectComponent {
	themes: HTMLElement[];

	constructor(private element: HTMLElement) {
		this.themes = Array.from(
			document.querySelectorAll('.js-intersect')
		) as HTMLElement[];

		this.themes.forEach(theme => {
			const observer = new IntersectionObserver(
				entries => {
					const [{ isIntersecting }] = entries;
					const intersectClass = theme.getAttribute('data-intersect-class') || '';
					if (intersectClass.length > 0) {
						if (isIntersecting) {
							this.element.classList.add(intersectClass);
						} else {
							this.element.classList.remove(intersectClass);
						}
					}
				},
				{
					rootMargin: '0px 0px -100%',
					threshold: [0, 0.1]
				}
			);
			observer.observe(theme);
		});
	}
}
